<template>
  <v-card tile class="mb-2 px-4 pt-2 pb-1" :elevation="elevation">
    <v-row no-gutters>
      <v-col cols="auto" style="width: 120px">
        <v-row no-gutters>
          <v-col class="d-flex align-center">
            <div class="caption d-flex flex-column">
              <div class="font-weight-bold">
                {{ activity.StartPosition }}
              </div>
              <div>{{ activity.StartTime | time }}</div>
            </div>
            <div
              class="d-flex align-start"
              style="height: 100%; padding-top: 3px"
            >
              <v-icon size="12" color="grey" class="mx-1"
                >mdi-arrow-right</v-icon
              >
            </div>

            <span class="caption d-flex flex-column">
              <div class="font-weight-bold">
                {{ activity.EndPosition }}
              </div>
              <div>{{ activity.EndTime | time }}</div>
            </span>
          </v-col>
        </v-row>
      </v-col>

      <v-col>
        <v-row no-gutters>
          <v-col>
            <div class="body-1 font-weight-bold">{{ fullName }}</div>
            <div
              class="caption grey--text text--darken-1"
              v-if="employee.PrimaryWorkTitle"
            >
              {{ employee.PrimaryWorkTitle }}
            </div>
          </v-col>
        </v-row>

        <v-row no-gutters>
          <v-col></v-col>
          <v-col cols="auto" class="d-flex align-center">
            <a
              :href="`tel:${employee.WorkPhone}`"
              v-if="employee.WorkPhone"
              class="mr-4"
            >
              <v-btn icon color="primary">
                <v-icon color="primary">
                  mdi-phone
                </v-icon>
              </v-btn>
            </a>
            <v-divider vertical />
            <v-btn icon class="ml-4" @click="goToWorkday">
              <v-icon color="primary">
                mdi-clipboard-account
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col
        cols="auto"
        v-if="$slots.default"
        class="d-flex flex-column align-end pl-4"
      >
        <slot />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { format } from 'date-fns'

export default {
  name: 'CrewListItem',

  props: {
    elevation: {
      type: [String, Number],
      default: () => 1
    },
    trip: Number,
    date: String,
    employee: Object,
    activities: Array
  },

  data: () => ({}),

  filters: {
    time(date) {
      return format(new Date(date), 'HH:mm')
    }
  },

  computed: {
    fullName() {
      return `${this.employee.FirstName} ${this.employee.LastName}`
    },

    activity() {
      return this.activities.find(x => x.Trip === this.trip)
    }
  },

  methods: {
    goToWorkday() {
      this.$router.push(`/workday/${this.date}/${this.employee.EmployeeNumber}`)
    }
  }
}
</script>

<style module>
.busTypeContainer {
  background: #ededed;
  border-top-right-radius: 99px;
  border-bottom-right-radius: 99px;
  margin-left: -16px;
  padding: 2px 16px;
  width: 180px;
}
</style>
